/* eslint react/display-name: "off" */

import React, {lazy} from 'react';
import {Route} from 'react-router-dom';
import _ from 'lodash';

import CrmPageWrapper from './Elements/CrmPageWrapper';
import checkUserAccess from '../../hoc/checkUserAccess';
import renderPopup from '../../../helpers/renderPopup';
import LoginPopup from '../../Elements/LoginPopup';

const MyContacts = lazy(() => import(/* webpackChunkName: "MyContacts" */ './MyContacts'));
const MyCompanies = lazy(() => import(/* webpackChunkName: "MyCompanies" */ './MyCompanies'));
const ContactPage = lazy(() => import(/* webpackChunkName: "ContactPage" */ './ContactPage'));
const CompanyPage = lazy(() => import(/* webpackChunkName: "CompanyPage" */ './CompanyPage'));
const MyProperties = lazy(() => import(/* webpackChunkName: "MyProperties" */ './MyProperties'));
const MyNotes = lazy(() => import(/* webpackChunkName: "MyNotes" */ './MyNotes'));
const ComingSoon = lazy(() =>
  import(/* webpackChunkName: "ComingSoon" */ '../../Elements/ComingSoon'));

const commingSoonComponent = props => (
  <CrmPageWrapper>
    <ComingSoon {...props} />
  </CrmPageWrapper>
);

const routesList = {
  '/crm/contacts': {
    controller: MyContacts,
  },
  '/crm/companies': {
    controller: MyCompanies,
  },
  '/crm/properties': {
    controller: MyProperties,
    options: {
      accessMessage: (
        <div className="empty">
          {/* eslint-disable-next-line no-irregular-whitespace */}
          <p>This is where the properties that you choose to save will be listed.  </p>
          <span className="text-normal">To access additional features, please </span>
          <a
            title="Please login or create account"
            className="search-link"
            onClick={(e) => {
              e.preventDefault();
              renderPopup(<LoginPopup />);
            }}
            href="#my-properties"
          >
            login or create account
          </a>
        </div>
      ),
    },
  },
  '/crm/notes': {
    controller: MyNotes,
    options: {
      accessMessage: (
        <div className="empty">
          {/* eslint-disable-next-line no-irregular-whitespace */}
          <p>This is where the notes that you save will be listed.  </p>
          <span className="text-normal">To access additional features, please </span>
          <a
            title="Login or create account"
            className="search-link"
            onClick={(e) => {
              e.preventDefault();
              renderPopup(<LoginPopup />);
            }}
            href="#my-notes"
          >
            login or create account
          </a>
        </div>
      ),
    },
  },
  '/crm/tasks': {
    controller: commingSoonComponent,
  },
  '/crm/deals': {
    controller: commingSoonComponent,
  },
  '/crm/contact/:title': {
    controller: ContactPage,
  },
  '/crm/company/:title': {
    controller: CompanyPage,
  },
};
function getRoutes() {
  const routes = [];
  _.each(routesList, (settigns, path) => {
    const AccessComponent = checkUserAccess(settigns.controller, settigns.options);
    routes.push(
      <Route key={path} path={path} element={<AccessComponent />} />,
    );
  });
  return routes;
}

export default getRoutes();
